import RequiredMark from '@components/FormFields/RequiredMark';
import { Button, Card, CircularProgress, LinearProgress } from '@hyperflake/react-ui-library';
import { FormHelperText, Label } from '@library/forms';
import { ErrorMessage, Form, Formik } from 'formik';
import useLinkEditForm from 'modules/links/hooks/useLinkEditForm';
import { PageTemplate } from 'modules/shared/features/content';
import { FormikInput } from 'modules/shared/features/formik';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const LinkEditForm = () => {
    const { clientId, projectId, linkId } = useParams();
    const navigate = useNavigate();

    const linkEditForm = useLinkEditForm(clientId, projectId, linkId);

    const handleSubmit = async (values: any) => {
        try {
            await linkEditForm.submit(values);
            toast.success('Link updated successfully');
            navigate(`/clients/${clientId}/projects/${projectId}/links`);
        } catch (err: any) {
            console.error(err);
            toast.error('Oops something went wrong.');
        }
    };

    if (linkEditForm.isFetching) {
        return <LinearProgress />;
    }

    return (
        <PageTemplate>
            <Formik
                initialValues={linkEditForm.initialValues}
                enableReinitialize
                validationSchema={linkEditForm.schema}
                onSubmit={handleSubmit}
            >
                {({ values }) => (
                    <Form>
                        <Card className="mt-4">
                            <Card.Header>Edit Link</Card.Header>
                            <Card.Body>
                                <div className="grid grid-cols-3 gap-4">
                                    <div className="col-span-1">
                                        <Label>
                                            Name <RequiredMark />
                                        </Label>
                                        <FormikInput type="text" name="name" />
                                        <FormHelperText variant={'error'}>
                                            <ErrorMessage name="name" />
                                        </FormHelperText>
                                    </div>
                                    <div className="col-span-2">
                                        <Label>
                                            Url <RequiredMark />
                                        </Label>
                                        <FormikInput type="text" name="url" />
                                        <FormHelperText variant={'error'}>
                                            <ErrorMessage name="url" />
                                        </FormHelperText>
                                    </div>
                                </div>
                                <Button type="submit" size={'lg'} className="mt-4" disabled={linkEditForm.isSubmitting}>
                                    {linkEditForm.isSubmitting ? (
                                        <CircularProgress size={20} color={'inherit'} />
                                    ) : (
                                        'Update'
                                    )}
                                </Button>
                            </Card.Body>
                        </Card>
                    </Form>
                )}
            </Formik>
        </PageTemplate>
    );
};

export default LinkEditForm;
